module.exports = __webpack_public_path__ + "static/media/nav_icon.87fce448.svg";